import PreparatoryStandardsPage from './_PreparatoryStandardsPage'

export default function LapFormerSettingsPage() {
  return <PreparatoryStandardsPage kind="lap-former" />
}
